import { render, staticRenderFns } from "./com-percent-dialog.vue?vue&type=template&id=7dd94a70&"
import script from "./com-percent-dialog.vue?vue&type=script&lang=js&"
export * from "./com-percent-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports